import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";

const PromoCodeModal = ({ open, onClose, hotelId, reload }) => {
    const [promoCodes, setPromoCodes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPromoCodes = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(
                `/manager/data/hotels/${hotelId}/get_common_promo_codes`,
            );
            setPromoCodes(response.data);

            setIsLoading(false);
        } catch (error) {
            console.error("Ошибка при получении промокодов:", error);
            setIsLoading(false);
        }
    };

    const copyCode = async (promoCode) => {
        try {
            setIsLoading(true);
            await axios.post("/manager/data/unique_promo_codes/copy", {
                hotelId,
                promoId: promoCode.id,
            });
            alert(`Промокод ${promoCode.name} скопирован.`);
            reload();
            setIsLoading(false);
        } catch (error) {
            alert("Ошибка копирования. Возможно, промокод уже скопирован.");
            console.error("Ошибка при копировании промокода:", error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchPromoCodes();
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={isLoading ? null : onClose}>
            <DialogTitle>Промокоды из других отелей</DialogTitle>
            <DialogContent>
                {isLoading ? (
                    <Box display="flex" justifyContent="center">
                        <CircularProgress />
                    </Box>
                ) : promoCodes?.length === 0 ? (
                    <Box>
                        <Typography>Нет общих промокодов</Typography>
                    </Box>
                ) : (
                    promoCodes.map((promoCode) => (
                        <Box display="flex" key={promoCode.id}>
                            <Typography
                                style={{ margin: "auto", fontWeight: "bold" }}
                            >
                                {promoCode.name}
                            </Typography>
                            <Button onClick={() => copyCode(promoCode)}>
                                Копировать
                            </Button>
                        </Box>
                    ))
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isLoading}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PromoCodeModal;
